import { ScrollLink } from "@/components/ui/scroll-link";
import type { Bitcoiner } from "@/types";
import { useEffect } from "react";

interface FeaturedBitcoinersProps {
  bitcoiners: Bitcoiner[];
}

export function FeaturedBitcoiners({ bitcoiners }: FeaturedBitcoinersProps) {
  if (!bitcoiners?.length) return null;

  // Debug logging
  useEffect(() => {
    console.log('Debug - Featured Bitcoiners:', bitcoiners.map(b => ({
      name: b.name,
      avatarUrl: b.avatarUrl
    })));
  }, [bitcoiners]);

  return (
    <section className="w-full">
      <h2 className="text-3xl font-bold tracking-tight mb-8">Featured Bitcoiners</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {bitcoiners.map((bitcoiner) => (
          <ScrollLink
            key={bitcoiner.id}
            to={`/people/${bitcoiner.slug}`}
            className="group flex flex-col items-center p-6 rounded-lg bg-card hover:bg-muted/50 transition-colors"
          >
            <div className="relative h-40 w-40 overflow-hidden rounded-full bg-muted">
              {bitcoiner.avatarUrl ? (
                <img
                  src={bitcoiner.avatarUrl}
                  alt={bitcoiner.name}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
                  onError={(e) => {
                    console.error('Image failed to load:', {
                      url: bitcoiner.avatarUrl,
                      name: bitcoiner.name
                    });
                    const target = e.target as HTMLImageElement;
                    target.src = "https://placehold.co/160x160/e5e7eb/a3a3a3?text=No+image";
                  }}
                  loading="lazy"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center">
                  <span className="text-lg text-muted-foreground">No image</span>
                </div>
              )}
            </div>
            <div className="mt-4 text-center">
              <h3 className="text-xl font-semibold">{bitcoiner.name}</h3>
              {bitcoiner.twitterHandle && (
                <p className="mt-1 text-sm text-muted-foreground">
                  @{bitcoiner.twitterHandle}
                </p>
              )}
            </div>
          </ScrollLink>
        ))}
      </div>
    </section>
  );
} 